import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Card, Button, Offcanvas, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { IconClose } from "../../../assets/icons";
import ApiHome from "../../../core/api/api.home";
import ContextApp from "../../../core/contexts/context.app";
function SearchModal({ data, showSearchModal, setShowSearchModal }) {
  console.log("data", data);
  const inputRef = useRef(null);
  const ctx = useContext(ContextApp);

  useEffect(() => {
    if (showSearchModal) {
      inputRef.current?.focus();
      const timer = setTimeout(() => {
        inputRef.current?.focus();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [showSearchModal]);

  const handleClose = () => {
    setShowSearchModal(false);
  };
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const handleSearch = (e) => {
    e.preventDefault();
    navigate("/search", { state: { searchText: searchText } });
    setShowSearchModal(false);
  };
  return (
    <Offcanvas
      placement="end"
      id="advancedMenu"
      show={showSearchModal}
      onHide={handleClose}
    >
      <Offcanvas.Header className=" border-bottom">
        <Offcanvas.Title className=" d-flex justify-content-between w-100">
          جستجو
          <div onClick={handleClose}>
            <IconClose fillColor="#000" />
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="bg-light">
        <Form onSubmit={handleSearch}>
          <Card className="rounded-3">
            <Card.Body>
              <Form.Label className="fs-normal  mb-3">
                عبارت مورد نظر را وارد کنید{" "}
              </Form.Label>
              <Form.Control
                type="text"
                // placeholder="جستجو ..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                ref={inputRef}
              ></Form.Control>
            </Card.Body>
          </Card>

          {/* کد‌های کارت‌های دیگر اینجا قرار می‌گیرند */}

          <Button type="submit" className="btn btn-success mt-3 w-100">
            جستجو{" "}
          </Button>
        </Form>
        <Row className="text-center amusement-group grid-2 gx-1 row-cols-3 mt-3">
          {data?.amusementGroups?.map((item) => (
            <Col>
              <Link
                onClick={handleClose}
                className="w-100 d-inline-block text-dark "
                to={
                  ctx.selectedCity?.englishName == undefined
                    ? `/c/${item.urlName?.split(" ").join("-")}`
                    : `/c/${ctx.selectedCity?.englishName}/${item.urlName
                        ?.split(" ")
                        .join("-")}`
                }
              >
                <div className="circle-box  mx-auto">
                  <img
                    src={
                      process.env.REACT_APP_API_URL +
                      item.imageUrl +
                      "?width=102"
                    }
                    alt={item.title}
                    className="w-75 mt-2 rounded-circle"
                  />
                  <span className="mb-3 mt-1 fs-065 px-1  text-truncate-1-line ">
                    {item.title}
                  </span>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
export default SearchModal;
